import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

enum monochromePalette {
  'black-100' = '#2E2F33',
  'gray-500' = '#4E5057',
  'gray-400' = '#546E7A',
  'gray-300' = '#78909C',
  'gray-200' = '#A6B2BF',
  'gray-150' = '#CFD8DC',
  'gray-100' = '#F3F6F7',
  'gray' = '#F7F8F9',
  'white-100' = '#FFFFFF',
}

enum colourPalette {
  'brand-100' = '#FEBA4A',
  'brand-200' = '#F37111',
  'blue-100' = '#008DFF',
  'blue-200' = '#0067FF',
  'red-100' = '#FF7275',
  'red-200' = '#F14649',
  'green-100' = '#3EDD88',
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-colors',
  templateUrl: './colors.component.html',
  styleUrls: ['./colors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorsComponent extends UIKitBaseComponent {
  private colors = {
    monochromePalette,
    colourPalette,
  };
  private lightColors: string[] = ['#F3F6F7', '#FFFFFF', '#CFD8DC', '#F7F8F9'];

  // @ts-expect-error
  @Input() type: string;
  get palette() {
    // @ts-expect-error
    return Object.keys(this.colors[this.type]).map(k =>
      // @ts-expect-error
      ({ color: k, value: this.colors[this.type][k] }),
    );
  }

  isLight(color: string) {
    return this.lightColors.find(lightColor => lightColor === color);
  }
}
